module.exports = __webpack_public_path__ + "img/question-dog.92fb3629.png";